import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material"

import React from "react"

function ModalConfirm({ onCancel, onApprove, open, title, description }) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth={"xs"}
            fullWidth
            scroll="paper"
        >
            <DialogTitle id="form-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <Typography variant="body1">{description}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="secondary" variant="outlined">
                    Cancelar
                </Button>
                <Button
                    type="button"
                    color="primary"
                    variant="contained"
                    onClick={onApprove}
                >
                    Excluir
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalConfirm
